import FeatureDetailsTexts from "@/v2-backoffice-client/feature/details/FeatureDetailsTexts"
import BasemapViewDetailsExtras from "@/v2-backoffice-client/basemap/view/BasemapViewDetailsExtras"
import BasemapViewDetailsHotfixTexts from "@/v2-backoffice-client/basemap/view/BasemapViewDetailsHotfixTexts"
import { IS_CATALOG_AUTHORING_ENABLED } from "@/v2-backoffice-client/feature/feature.constants"
import type { BasemapFragment } from "@/v2-backoffice-client/basemap/__types__/basemap.fragment"

export type BasemapViewDetailsProps = {
  basemap: BasemapFragment
}

/**
 * Details form of the basemap sheet: how the basemap presents itself in the
 * console's chooser (tile, position) and its name/description in every
 * supported language — the same TranslationEditor embed the layer sheet
 * uses, so text goes through one pipeline for the whole catalog.
 */
function BasemapViewDetails(props: BasemapViewDetailsProps) {
  const { basemap } = props

  return (
    <div className="flex flex-col gap-6 pt-2">
      <BasemapViewDetailsExtras basemap={basemap} />

      {IS_CATALOG_AUTHORING_ENABLED ? (
        <FeatureDetailsTexts
          featureCode={basemap.FeatureCode}
          subject="basemap"
          featureCodeLabel="Basemaps"
        />
      ) : (
        <BasemapViewDetailsHotfixTexts basemap={basemap} />
      )}
    </div>
  )
}

export default BasemapViewDetails
